import React from "react";
import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";
import { FormatQuote } from "@mui/icons-material";

const gold = "#C29D59";
const darkBg = "#111";
const lightText = "rgba(255,255,255,0.85)";

const testimonials = [
  {
    name: "Aarav Mehta",
    role: "Homeowner, Bengaluru",
    content:
      "InteriorVista completely transformed our living space! The attention to detail and design aesthetics were beyond our expectations.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Sanya Kapoor",
    role: "Restaurant Owner, Mumbai",
    content:
      "Their team brought our restaurant to life. The blend of modern and rustic elements created the perfect atmosphere for our brand.",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Vikram Rao",
    role: "Corporate Client, Hyderabad",
    content:
      "Working with InteriorVista was a delight. The workspace design improved our team’s morale and boosted productivity.",
    avatar: "https://randomuser.me/api/portraits/men/65.jpg",
  },
  {
    name: "Priya Sharma",
    role: "Apartment Owner, Pune",
    content:
      "They understood our vision perfectly. Every corner of our home now reflects elegance and warmth. Highly recommended!",
    avatar: "https://randomuser.me/api/portraits/women/66.jpg",
  },
  {
    name: "Rahul Nair",
    role: "Villa Owner, Kochi",
    content:
      "From concept to execution, everything was seamless. The color palette and textures were simply stunning!",
    avatar: "https://randomuser.me/api/portraits/men/12.jpg",
  },
  {
    name: "Neha Verma",
    role: "Boutique Owner, Delhi",
    content:
      "Their creative approach gave my store a luxurious and inviting appeal. Customers often compliment our interiors!",
    avatar: "https://randomuser.me/api/portraits/women/68.jpg",
  },
];

const Testimonials = () => {
  return (
    <Box
      id="testimonials"
      sx={{
        backgroundColor: darkBg,
        color: "#fff",
        py: 10,
        mt:8,
        px: { xs: 3, md: 8 },
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <Typography variant="subtitle2" sx={{ color: gold, textTransform: "uppercase", letterSpacing: 1 }}>
        Testimonials
      </Typography>

      <Typography variant="h3" sx={{ fontWeight: 700, mb: 1,fontSize:{sm:"45px",xs:"32px"} }}>
        What Our Clients <Box component="span" sx={{ color: gold }}>Say</Box>
      </Typography>

      <Typography sx={{ color: "#b0b0b0ff", maxWidth: 800, mx: "auto", mb: 6 }}>
        Don't just take our word for it. Here's what our satisfied clients  have to say <br /> about their experience.
      </Typography>

      {/* Cards container using Box (flex-wrap) */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "center",
        }}
      >
        {testimonials.map((t, idx) => (
          <Box
            key={idx}
            sx={{
              // responsive width: 1 column on xs, 2 on sm, 3 on md+
              mt:4,
              width: { xs: "100%", sm: "48%", md: "31.33%" },
              minWidth: { md: "310px" }, // prevents extremely narrow cards on very wide screens with many gaps
            }}
          >
            <Card
              sx={{
                backgroundColor: "#1a1a1a",
                color: "#fff",
                borderRadius: 3,
                border: "1px solid rgba(255,255,255,0.06)",
                p: 2,
             
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "transform 0.28s ease, box-shadow 0.28s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.45)",
                },
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <FormatQuote sx={{ fontSize: 38, color: gold, mb: 1 }} />
                <Typography
                  variant="body1"
                  sx={{ color: lightText, mb: 4, fontStyle: "italic", lineHeight: 1.6 }}
                >
                  “{t.content}”
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                  <Avatar
                    src={t.avatar}
                    alt={t.name}
                    sx={{ width: 56, height: 56, border: `2px solid ${gold}` }}
                  />
                  <Box sx={{ textAlign: "left" }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#fff" }}>
                      {t.name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: lightText }}>
                      {t.role}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Testimonials;
